export default __webpack_public_path__ + "static/media/oreilly.308c0ecb.png";